module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"customer.field.address.placeholder":"ที่อยู่ในการติดต่อลูกค้า","customer.field.phone.placeholder":"เบอร์ที่ใช้ติดต่อได้","customer.field.email.placeholder":"อีเมล์ที่ใช้ติดต่อ","customer.field.nick_name.placeholder":"ชื่อที่ใช้เรียกกัน"}}')
  delete Component.options._Ctor
}
